import { type ScenarioKey, applyScenarioDefaults } from "./mswScenarios.ts";

const STORAGE_KEY = "msw-scenarios";
const SCHEMA_VERSION = 1;

interface StoredScenarios {
    version: number;
    enabled: Record<string, boolean>;
}

function readPersistedScenarios(): Record<string, boolean> {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {};
        }

        const parsed: StoredScenarios = JSON.parse(raw);
        if (parsed.version !== SCHEMA_VERSION) {
            localStorage.removeItem(STORAGE_KEY);

            return {};
        }

        return parsed.enabled;
    } catch {
        localStorage.removeItem(STORAGE_KEY);

        return {};
    }
}

function readStore(): Record<string, boolean> {
    return applyScenarioDefaults(readPersistedScenarios());
}

function writeStore(enabled: Record<string, boolean>): void {
    try {
        const data: StoredScenarios = { version: SCHEMA_VERSION, enabled };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
        console.warn("[mswScenarioStore] Failed to persist scenarios to localStorage.");
    }
}

export function getEnabledScenarios(): Record<string, boolean> {
    return readStore();
}

export function isScenarioEnabled(key: string): boolean {
    return readStore()[key] ?? false;
}

export function setScenarioEnabled(key: ScenarioKey, enabled: boolean): void {
    const store = readStore();
    store[key] = enabled;
    writeStore(store);
}

export function setAllScenarios(enabled: Record<string, boolean>): void {
    writeStore(enabled);
}
